import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import { FormFieldContainer, FormFieldInput } from "../../../react-components/modals/modal-form-elements";
import { Checkbox } from "../../../react-components/page-framework/checkbox";
import { AccreditedInvestorTypes } from "../redux/profile/constants";
import { SetProfileStatePayload, SetProfileStateAction, ProfileModuleState } from "../redux/profile/types";
import { setProfileState } from "../redux/profile/actions";
import { AccountType } from "../../../redux/types/account-type";
import isEmpty from "lodash.isempty";

interface MapDispatchProps {
  setProfileState: (payload: SetProfileStatePayload) => SetProfileStateAction;
}

interface MapStateProps {
  accountType: AccountType | null;
}

export type Props = MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { setProfileState, accountType } = props;
  const [isOtherOption, setOtherOption] = React.useState(false);
  
  React.useEffect(() => {
    const isOtherOption = !AccreditedInvestorTypes.map((i) => i.title).includes(accountType?.description);
    if (isOtherOption && !isEmpty(accountType?.description)) {
      setOtherOption(isOtherOption);
    }
  }, [accountType]);

  return (
    <>
      <FormFieldContainer>
        <label>Are you an accredited investor?</label>
      </FormFieldContainer>
      {AccreditedInvestorTypes.map((accreditation) => (
        <Checkbox
          key={`accountType-${accreditation.title}`}
          checked={accountType?.description === accreditation.title}
          onChange={() => {
            setProfileState({ accountType: { ...accountType, description: accreditation.title } });
            setOtherOption(false);
          }}
          label={
            <div>
              <p>{accreditation.title}</p>
            </div>
          }
        />
      ))}
      <Checkbox
        checked={isOtherOption}
        onChange={() => {
          setProfileState({ accountType: { ...accountType, description: null } });
          setOtherOption(true);
        }}
        label={
          <div>
            <p>Other</p>
          </div>
        }
      />
      {isOtherOption && (
        <FormFieldContainer>
          <label>Please specify other accredited investor type:</label>
          <FormFieldInput>
            <textarea
              onChange={(e) => setProfileState({ accountType: { ...accountType, description: e.target.value } })}
            >
              {accountType?.description}
            </textarea>
          </FormFieldInput>
        </FormFieldContainer>
      )}
    </>
  );
};

const mapState = (state: AppState & ProfileModuleState) => ({
  investorType: state.profile.investorType,
  accountType: state.profile.accountType,
});

const mapDispatch = {
  setProfileState: setProfileState,
};

export const AccreditedInvestorType = connect(mapState, mapDispatch)(Component);
